module.exports = __webpack_public_path__ + "img/img_flag_bz.b2eb8185.png";